export const commonStyles = {
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fontBase: {
    fontFamily: 'Poppins',
    color: '#000',
  },
  hideScrollbar: {
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  responsiveContainer: {
    overflowX: 'auto',
    gap: '10px',
    padding: '10px 0',
    flexWrap: 'nowrap',
  },
  textStyles: {
    title: {
      fontSize: '20px',
      fontWeight: '500',
      lineHeight: '1',
    },
    description: {
      fontSize: '16px',
      fontWeight: '400',
      lineHeight: '1.5',
    },
    price: {
      fontSize: '18px',
      fontWeight: '500',
      lineHeight: '1',
      textWrap: 'nowrap',
    },
  },
};

export const styles = {
  FeaturedMenu: {
    backgroundColor: '#fff',
  },
  // This is the BaseContainer style - should NOT have horizontal scroll
  Container: {
    padding: '100px 55px',
    width: '100%',
    '@media (max-width: 780px)': {
      padding: '50px 22px',
    },
  },

  Container_Mobile: {
    padding: '100px 22px',
    width: '100%',
  },

  // These are the menu item containers that SHOULD have horizontal scroll
  MenuItemsContainer: {
    display: 'flex',
    gap: '20px',
    width: '100%',
    maxWidth: '100%',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    padding: '16px 0',
    ...commonStyles.hideScrollbar,
    '@media (max-width: 780px)': {
      padding: '10px 0',
      gap: '10px',
    },
  },

  MenuItemsContainerMobile: {
    display: 'flex',
    overflowX: 'auto',
    width: '100%',
    maxWidth: '100%',
    gap: '10px',
    padding: '10px 0',
    flexWrap: 'nowrap',
    ...commonStyles.hideScrollbar,
  },

  ContentWrapper: {
    ...commonStyles.flexColumn,
    gap: '30px',
  },
  TextWrapper: {
    ...commonStyles.flexColumn,
    alignItems: 'center',
    gap: '15px',
  },
  Heading: {
    color: '#000',
    fontSize: '60px',
    fontWeight: '700',
    lineHeight: '1.5',
    textAlign: 'center',
  },
  Description: {
    ...commonStyles.textStyles.description,
    ...commonStyles.fontBase,
    textAlign: 'center',
  },
  ButtonWrapper: {
    ...commonStyles.flexCenter,
    marginTop: '30px',
  },
  Button: {
    color: '#000',
    borderColor: '#000',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  MainImage: {
    height: '280px',
    width: '350px',
    objectFit: 'contain',
    transition: 'transform 0.6s ease',
    '@media (max-width: 780px)': {
      height: '230px',
      width: '280px',
    },
    '&:hover': {
      transform: 'scale(1.08)',
    },
  },
  MainImage_Mobile: {
    height: '230px',
    width: '280px',
    objectFit: 'contain',
    transition: 'transform 0.6s ease',
    '&:hover': {
      transform: 'scale(1.08)',
    },
  },
  MenuItem: {
    minWidth: '250px',
    width: '250px',
    flexShrink: 0,
    borderRadius: '40px',
    padding: '24px',
    cursor: 'pointer',
    gap: '20px',
    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: '#ffffff',
    '@media (max-width: 780px)': {
      minWidth: '120px',
      width: '120px',
      flexShrink: 0,
      borderRadius: '16px',
      padding: '10px',
      gap: '2px',
    },
  },
  MenuItem_Mobile: {
    minWidth: '120px',
    width: '120px',
    flexShrink: 0,
    borderRadius: '16px',
    padding: '10px',
    gap: '2px',
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
  },
  ImageItem: {
    position: 'relative',
    overflow: 'hidden',
    maxWidth: '202px',
    height: '195px',
    '& img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '202px',
      height: '195px',
      objectFit: 'cover',
      borderRadius: '8px',
      transition: 'transform 0.6s ease',
      '@media (max-width: 780px)': {
        maxHeight: '180px',
        maxWidth: '100%',
      },
    },
    '&:hover img': {
      transform: 'scale(1.08)',
    },
  },
  ImageItem_Mobile: {
    overflow: 'hidden',
    height: '85px',
    width: '100%',
    borderRadius: '8px',
    '& img': {
      width: '100%',
      height: '78px',
      maxHeight: '78px',
      maxWidth: '100%',
      objectFit: 'cover',
      borderRadius: '8px',
      transition: 'transform 0.6s ease',
    },
    '&:hover img': {
      transform: 'scale(1.08)',
    },
  },
  MenuItemTitle: {
    ...commonStyles.textStyles.title,
    ...commonStyles.fontBase,
    width: '90%',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    paddingBottom: '2px',
    '@media (max-width: 780px)': {
      WebkitLineClamp: 4,
    },
  },
  MenuItemDescription: {
    ...commonStyles.textStyles.description,
    ...commonStyles.fontBase,
  },
  MenuItemPrice: {
    ...commonStyles.textStyles.price,
    ...commonStyles.fontBase,
    width: '25%',
    minWidth: '80px',
    textAlign: 'start',
  },
  mainItemWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '30px',
    '@media (max-width: 780px)': {
      flexDirection: 'column',
      gap: '10px',
    },
  },
  mainItemTextWrapper: {
    ...commonStyles.flexColumn,
    gap: '20px',
    padding: '28px 0px 0px 0px',
    width: '70%',
    '@media (max-width: 780px)': {
      padding: 0,
      gap: '10px',
      alignItems: 'center',
    },
  },
  mainItemWrapper_Mobile: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '10px',
  },
  mainItemTextWrapper_Mobile: {
    ...commonStyles.flexColumn,
    gap: '8px',
    padding: '20px 0px 0px 0px',
    width: '100%',
  },
};
export const VariantFourStyles = {
  Main: {
    backgroundColor: '#fff',
    overflow: 'visible',
    justifyContent: 'end',
  },
  Image: {
    width: '70px',
    height: '70px',
    '& img': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '70px',
      height: '70px',
      objectFit: 'cover',
      '@media (max-width: 780px)': {
        maxHeight: '100%',
        maxWidth: '100%',
      },
    },
  },
  Image_Mobile: {
    overflow: 'hidden',
    width: '70px',
    height: '70px',
    '& img': {
      width: '70px',
      height: '70px',
      objectFit: 'cover',
    },
  },
  MenuWrapper: {
    ...commonStyles.flexColumn,
    gap: '22px',
    marginTop: '30px',
  },
  CardWrapper: {
    padding: '0 13%',
    display: 'flex',
    width: '100%',
    '@media (max-width: 780px)': {
      padding: '50px 22px',
    },
  },
  CardWrapper_Mobile: {
    padding: '0px 22px',
    width: '100%',
  },
  Card: {
    borderRadius: '0px',
    height: 'fit-content',
    width: '530px',
    padding: '30px 22px',
    '@media (max-width: 780px)': {
      width: '100%',
    },
  },
  Card_Mobile: {
    borderRadius: '0px',
    height: 'fit-content',
    width: '90%',
    maxWidth: '530px',
    padding: '30px 22px',
  },
  ContentContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignSelf: 'center',
  },
  TopBorder: {
    borderTop: '0.6px solid #0000001A',
    flex: 1,
    alignSelf: 'center',
    marginX: '14px',
  },
  BottomBar: {
    height: '170px',
  },
};
